import React, { useEffect, useState } from "react";
import "./footer.css";
import { getSubPageData } from "../../../services/footerServices";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useReducerHook from "../../../hooks/useReducerHook";
import useNavigateMenuId from "../../../hooks/useMenuId";
import { APP_URL } from "../../../shared/baseUrl";

const Footer = () => {
  const location = useLocation();

  const settingsData = useSelector((state) => state?.settingData.settingDatas);
  const siteName = settingsData?.find(
    (item) => item?.key_name === "SITE_NAME"
  )?.key_value;
  const addressOne = settingsData?.find(
    (item) => item?.key_name === "ADDRESS_ONE"
  )?.key_value;
  const addressTwo = settingsData?.find(
    (item) => item?.key_name === "ADDRESS_TWO"
  )?.key_value;
  const phoneOne = settingsData?.find(
    (item) => item?.key_name === "PHONE_ONE"
  )?.key_value;
  const phoneTwo = settingsData?.find(
    (item) => item?.key_name === "PHONE_TWO"
  )?.key_value;
  const emailOne = settingsData?.find(
    (item) => item?.key_name === "EMAIL_ONE"
  )?.key_value;
  const emailTwo = settingsData?.find(
    (item) => item?.key_name === "EMAIL_TWO"
  )?.key_value;
  const siteLogo = settingsData?.find(
    (item) => item?.key_name === "SITE_LOGO"
  )?.key_value;
  const [subPageData, setSubPageData] = useState([]);
  useEffect(() => {
    getSubpageDataList();
  }, []);
  const getSubpageDataList = async () => {
    try {
      const response = await getSubPageData();
      setSubPageData(response.data);
    } catch (error) {}
  };
  const navigate = useNavigate();
  const { pageMenus } = useReducerHook();
  const { navigatePageId } = useNavigateMenuId();
  const formatPageName = (name) => name?.replace(/\s+/g, "-").toLowerCase();
  function reWriteHeader() {
    let data = pageMenus?.headerMenuData?.map((x) => {
      return {
        ...x,
        page_slug: x?.page_slug === "home" ? "" : x?.page_slug,
      };
    });
    return data;
  }
  return (
    <footer>
      <div className="container">
        <div className="row py-5">
          <div className="col-lg-2 col-md-6 col-sm-12 d-flex align-items-center mb-md-0 mb-4">
            <img
              src={APP_URL + siteLogo}
              alt=""
              width={180}
              className="img-fluid pointer"
              onClick={() => navigate("/")}
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 mb-md-0 mb-4">
            <div className="col-12">
              <h5 className="footer-header-contents">OUR POLICIES</h5>
              <ul className="list-unstyled footer_anchors">
                {subPageData?.filter((x)=>x?.page_name !== "About us")?.map((item) => (
                  <li className=" footer-ptagg" key={item?.page_id}>
                    <p
                      onClick={() => {
                        const formattedPageName = formatPageName(
                          item?.page_name
                        );
                        navigate(`/policy/${formattedPageName} `, {
                          state: { stateId: item?.page_id },
                        });
                      }}
                     className={`site-hover ${
                         `/policy/${formatPageName(
                             item?.page_name
                    )}` === location?.pathname
                     ? "active-color fw-bold"
                        : ""
                               } `}
                      style={{ cursor: "pointer" }}
                    >
                      {item?.page_name}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 mb-md-0 mb-4">
            <div className="widget">
              <h5 className="footer-header-contents">CONTACT US</h5>
              <ul className="list-unstyled">
                <li>
                  <label
                    className="footer-header-contents"
                    style={{
                      fontWeight: "700",
                      color: "var(--default-text-color-gentlemenz)",
                    }}
                  >
                    Address :
                  </label>
                  <div>
                    <p
                      className="footer-ptagg"
                      dangerouslySetInnerHTML={{
                        __html: addressOne ? addressOne : addressTwo,
                      }}
                    />
                  </div>
                </li>
                <li className=" mt-2">
                  <label
                    className="footer-header-contents"
                    style={{
                      fontWeight: "700",
                      color: "var(--default-text-color-gentlemenz)",
                    }}
                  >
                    Phone :
                  </label>
                  <span style={{ color: "var(--default-bg-color" }}>
                    {phoneOne ? phoneOne : phoneTwo}
                  </span>
                </li>
                <li className=" mt-2">
                  <label
                    className="footer-header-contents"
                    style={{
                      fontWeight: "700",
                      color: "var(--default-text-color-gentlemenz)",
                    }}
                  >
                    Email :
                  </label>
                  <span style={{ color: "var(--default-bg-color" }}>
                    {emailOne ? emailOne : emailTwo}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="widget">
              <h5 className="widget-title footer-header-contents">
                OUR SERVICE
              </h5>
              <ul className="list-unstyled text-white pointer footer_anchors">
                {reWriteHeader()?.map((menu) => (
                  <li
                    key={menu?.page_id}
                    // className={`pointer site-hover${
                    //   `/${menu?.page_slug}` === location?.pathname
                    //     ? "active-color"
                    //     : ""
                    // }`}
                    onClick={() => navigatePageId(menu)}
                  >
                    <span
                      className={`site-hover ${
                        `/${menu?.page_slug}` === location?.pathname
                          ? "active-color fw-bold"
                          : ""
                      }`}
                    >
                      {menu?.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom-content">
        <div
          className="container d-flex justify-content-center"
          style={{ color: "var( --default-bg-color)" }}
        >
          Copyright © {new Date().getFullYear()} {siteName}. All Rights
          Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
